import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function requestPillars(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_PILLARS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/pillars' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestPillars',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestPillars')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getPillarsSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestPillarsFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestPillars')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getPillarsFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/pillars.js